import React, { useState, useContext } from 'react';
import {
  Layout,
  Menu,
  Button,
  Row,
  Col,
  Avatar,
  Dropdown,
  // Space,
  theme,
  Typography,
} from 'antd';
import {
  FaChartBar,
  FaBook,
  FaUserGraduate,
  FaBookReader,
  FaUserTie,
  // FaGraduationCap,
  FaBars,
  FaUserCog,
  FaPowerOff,
  FaAngleDown,
  FaUsers
} from "react-icons/fa"; //Font Awesome 5
import { Outlet, Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import logo from '../assets/logo.png';
import { AuthContext } from '../contexts/AuthContext';

const { Header, Content, Footer, Sider } = Layout;

const activedKey = (currentPath) => {

  const sub = currentPath.indexOf('/', 7);

  if (sub !== -1) {
    currentPath = currentPath.substring(0, sub);
  }

  switch (currentPath) {
    case '/admin/dashboard': return '1'
    case '/admin/orders': return '2'
    case '/admin/students': return '3'
    case '/admin/courses': return '40'
    case '/admin/products': return '41'
    case '/admin/categories': return '41'
    case '/admin/users': return '5'
    case '/admin/attendance': return '6'
    default: return null;
  }
}

const adminMenus = [
  {
    key: '1',
    icon: <FaChartBar />,
    label: <Link to={`/admin/dashboard?start_date=${dayjs().toISOString()}&end_date=${dayjs().add(1, 'days').toISOString()}`}>dashboard</Link>,
    // label: <Link to={`/admin/dashboard?start_date=${dayjs().toISOString()}&end_date=${dayjs().add(31,'days').toISOString()}`}>dashboard</Link>,
  },
  {
    key: '2',
    icon: <FaBook />,
    label: <Link to={'/admin/orders'}>orders</Link>,
  },
  {
    key: '3',
    icon: <FaUserGraduate />,
    label: <Link to={'/admin/students'}>students</Link>,
  },
  {
    key: '6',
    icon: <FaUsers />,
    label: <Link to={'/admin/attendance'}>attendance</Link>,
  },
  {
    key: '4',
    icon: <FaBookReader />,
    label: 'products',
    children: [
      {
        key: '40',
        label: <Link to={'/admin/courses'}>courses</Link>,
      },
      {
        key: '41',
        label: <Link to={'/admin/products'}>products</Link>,
      },
      {
        key: '42',
        label: <Link to={'/admin/categories'}>categories</Link>,
      },
    ]
  },
  {
    key: '5',
    icon: <FaUserTie />,
    label: <Link to={'/admin/users'}>users</Link>,
  }
]

const teacherMenus = [
  {
    key: '3',
    icon: <FaUserGraduate />,
    label: <Link to={'/admin/students'}>students</Link>,
  },
  {
    key: '4',
    icon: <FaBookReader />,
    label: 'products',
    children: [
      {
        key: '40',
        label: <Link to={'/admin/courses'}>courses</Link>,
      },
      {
        key: '41',
        label: <Link to={'/admin/products'}>products</Link>,
      },
      {
        key: '42',
        label: <Link to={'/admin/categories'}>categories</Link>,
      },
    ]
  }
]

function AdminLayout() {
  const redirect = useNavigate();
  const { user } = useContext(AuthContext);
  const userData = JSON.parse(user);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isBreakpoint, setIsBreakpoint] = useState(false);
  const {
    token: { colorBgContainer, sidbarBackground },
  } = theme.useToken();

  const onCollapse = (collapsed, type) => {
    setIsCollapsed(collapsed);
  };
  const onLogout = () => {
    localStorage.clear();
    window.location.replace('/');
  }
  // const currentPath =window.location.pathname.slice
  // console.log(userData);
  // console.log(window.location.pathname.lastIndexOf("/"));

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        trigger={null}
        breakpoint="lg"
        collapsedWidth="0"
        collapsed={isCollapsed}
        onCollapse={onCollapse}
        style={{
          background: sidbarBackground,
          overflow: 'auto',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 999
        }}
        onBreakpoint={(broken) => {
          setIsBreakpoint(broken);
        }}
      // onCollapse={(collapsed, type) => {
      //   console.log(collapsed, type);
      // }}
      >
        <Row justify='center' >
          <Col>
            <div style={{ height: '64px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Avatar src={logo} size={56} style={{ padding: '4px' }} />
              {/* <div>
                <span className='logo-vertical' style={{ color: '#FFB347' }}>
                  SLC
                </span>
                <span className='logo-vertical' >
                  LMS
                </span>
                <FaGraduationCap style={{ fontSize: '40px', color: '#FFB347' }} />
              </div> */}
            </div>
          </Col>
        </Row>
        <Menu
          // theme="dark"
          mode="inline"
          // defaultSelectedKeys={['4']}
          selectedKeys={activedKey(window.location.pathname)}
          items={userData.role === 'ADMIN' ? adminMenus : teacherMenus}
          style={{
            background: sidbarBackground,
            color: "#9e9b9b",
            border: 'none'
          }}
        />
      </Sider>
      <Layout>
        <Header style={{ padding: 0, background: colorBgContainer, borderBottom: '2px solid #F0F0F0' }} >
          <Row justify="space-between">
            <Col>
              <Button
                type='text'
                icon={<FaBars style={{ color: '#FFB347', fontSize: '18px' }} />}
                onClick={() => setIsCollapsed(!isCollapsed)}
                style={{ marginLeft: isCollapsed ? '16px' : '216px' }}
              />
            </Col>
            <Col style={{ marginRight: '16px' }}>
              <Row gutter={[8, 8]}>
                <Col>
                  <Row >
                    <Col>
                      <Avatar
                        style={{
                          background: '#fbe9cf',
                          color: '#ff7e00',
                          fontWeight: 'bold',
                          marginRight: '8px'
                        }}
                      >
                        {userData.username.charAt(0).toUpperCase()}
                      </Avatar>
                    </Col>
                    <Col>
                      <Typography.Text style={{ margin: '0px', padding: '0px', marginRight: '8px' }}>
                        {userData.role}
                      </Typography.Text>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Dropdown
                    menu={{
                      items: [
                        {
                          key: '1',
                          label: 'ข้อมูลส่วนตัว',
                          icon: <FaUserCog />,
                          onClick: () => redirect('/admin/users/profile')
                        },
                        {
                          key: '2',
                          label: 'ออกจากระบบ',
                          icon: <FaPowerOff />,
                          onClick: onLogout
                        },
                      ]
                    }}
                  >
                    <FaAngleDown />
                  </Dropdown>
                </Col>
              </Row>
            </Col>
          </Row>
        </Header>
        <Content
          style={{ margin: '16px', marginLeft: isBreakpoint ? '16px' : isCollapsed ? '16px' : '216px' }}

        >
          <Outlet />
        </Content>
        <Footer style={{ textAlign: 'center' }}>School management Builder 20260306</Footer>
      </Layout>
    </Layout >
  )
}

export default AdminLayout